/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { withApollo } from '@apollo/client/react/hoc';
import mbpLogger from 'mbp-logger';
import { string, object } from 'prop-types';
import getBrandDomainById from '../../../helpers/getBrandDomain';
import findSkuByPartNumbers from '../../../gql/queries/findSkuByPartNumbers';
import mbpUtil from 'mbp-api-util';

const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

const ProductLink = ({ productName, productBrand, brandID, productSku, history, client }) => {
    const [url, setUrl] = useState('');
    const getSkuByPartNumbers = (query) => {
        return client.query({ query }).then((res) => res);
    }

    const getProductLink = () => {
        const brandDomain = brandID ? getBrandDomainById(brandID) : '';
        if (productSku && productBrand && brandDomain) {
            const SKU_BY_PART = findSkuByPartNumbers(brandDomain, `["${productBrand}-${productSku}"]`, 'parentProduct{seo{url}}');
            getSkuByPartNumbers(SKU_BY_PART).then((res) => {
                const url = res?.data?.findSkuByPartNumbers?.[0]?.parentProduct?.seo?.url || '';
                setUrl(url);
            }).catch((error) => {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    query: SKU_BY_PART,
                    component: 'ProductLink.js',
                    message: 'Error loading data from Graphql',
                    error,
                });
            });
        }
    };

    useEffect(() => {
        getProductLink();
    }, [])

    const handleRedirect = () => url && history.push(url);
    return (
        <div className="productLink">
            <span tabIndex={0} role="button" onClick={productBrand !== '1032' && REACT_APP_INJECTABLE !== 'false' ? handleRedirect : () => { }} onKeyDown={() => { }} className={`item-title ${(productBrand !== '1032' && url) ? 'link' : ''} ${REACT_APP_INJECTABLE === 'false' ? 'nolink' : ''}`}>
                <ReactMarkdown className={`reactMarkdownLink`} children={productName} />
            </span>
        </div>
    );
}

ProductLink.propTypes = {
    brandID: string.isRequired,
    productSku: string.isRequired,
    productName: string.isRequired,
    history: object.isRequired,
    client: object.isRequired, // Apollo Client
    productBrand: string.isRequired,
};

export default withApollo(ProductLink);